import { Button } from 'flowbite-react'
import { useState, useEffect } from 'react'

interface IManualQuestionProps {
    onAdd: (q: any) => void;
}

const AddQuestionsManual = ({ onAdd }: IManualQuestionProps) => {
    const [question, setQuestion] = useState<string>('')
    const [choiceA, setChoiceA] = useState<string>('')
    const [choiceB, setChoiceB] = useState<string>('')
    const [choiceC, setChoiceC] = useState<string>('')
    const [choiceD, setChoiceD] = useState<string>('')
    const [answer, setAnswer] = useState<string>('A')

    const add = () => {
        const q = {
            question,
            choice_a: choiceA,
            choice_b: choiceB,
            choice_c: choiceC,
            choice_d: choiceD,
            ans: answer,
        }
        onAdd(q)
        setQuestion('')
        setChoiceA('')
        setChoiceB('')
        setChoiceC('')
        setChoiceD('')
        setAnswer('A')
    }

    const [EditorComp, setEditorComp] = useState<any>(null);

    useEffect(() => {
        let mounted = true;
        (async () => {
            try {
                const mod = await import('quill-editor-math');
                if (!mounted) return;
                const Comp = (mod && (mod.default || mod));
                setEditorComp(() => Comp);
                try { await import('quill-editor-math/dist/index.css'); } catch (e) { }
            } catch (e) {
                // ignore
            }
        })();
        return () => { mounted = false; };
    }, []);

    return (
        <div>
            <h1 className='pb-3 pt-3 font-bold'>Add a question manually</h1>
            <div className='space-y-3'>
                <div>
                    <div className='mb-2 font-medium'>Question</div>
                    {EditorComp ? <EditorComp initialValue={question} onChange={(v: any) => setQuestion(v)} /> : <div>Loading editor…</div>}
                </div>

                <div>
                    <div className='mb-2 font-medium'>Choice A</div>
                    {EditorComp ? <EditorComp initialValue={choiceA} onChange={(v: any) => setChoiceA(v)} /> : <div>Loading editor…</div>}
                </div>

                <div>
                    <div className='mb-2 font-medium'>Choice B</div>
                    {EditorComp ? <EditorComp initialValue={choiceB} onChange={(v: any) => setChoiceB(v)} /> : <div>Loading editor…</div>}
                </div>

                <div>
                    <div className='mb-2 font-medium'>Choice C</div>
                    {EditorComp ? <EditorComp initialValue={choiceC} onChange={(v: any) => setChoiceC(v)} /> : <div>Loading editor…</div>}
                </div>

                <div>
                    <div className='mb-2 font-medium'>Choice D</div>
                    {EditorComp ? <EditorComp initialValue={choiceD} onChange={(v: any) => setChoiceD(v)} /> : <div>Loading editor…</div>}
                </div>

                <div className='flex items-center gap-3'>
                    <label className='font-medium'>Answer</label>
                    <select aria-label="Answer choice" value={answer} onChange={(e) => setAnswer(e.target.value)} className='rounded border p-2'>
                        <option value='A'>A</option>
                        <option value='B'>B</option>
                        <option value='C'>C</option>
                        <option value='D'>D</option>
                    </select>
                </div>

                <div className='flex justify-center'>
                    <Button onClick={add}>Add to list</Button>
                </div>
            </div>
        </div>
    )
}

export default AddQuestionsManual
